import React from 'react'
import DbMenuIcon from "../components/Svg/DbMenuIcon"
import user from "../assets/user.svg"

function MobileDH(props) {
  return (
    <div className="mobile-dashboard-header">
      <div className="dh-icon-group" onClick={props.onClick}>
      <DbMenuIcon className="dh-icon" fill="#7A8996"/>
      </div>
       <div className="user-prof">
            <img className="user-icon" src={user} alt="icon" />
           <h4>{props.profilename}</h4>
       </div>
   </div>
  )
}

export default MobileDH